import { AddressbarColor } from 'quasar'
import InlineSvg from 'vue-inline-svg'
import PortalVue from 'portal-vue'
import auth from 'src/mixins/auth'
import layout from 'src/mixins/layout'
import responsivity from 'src/mixins/responsivity'
import currency from 'src/mixins/currency'
import { boot } from 'quasar/wrappers'
import { Icon } from '@iconify/vue'
import { install as installConsoleCapture } from 'src/utils/consoleCapture'

AddressbarColor.set('#003250')

installConsoleCapture()

export default boot (({ app }) => {
  app.component('inline-svg', InlineSvg)
  app.component('IconifyIcon', Icon)
  app.use(PortalVue)
  app.mixin(auth)
  app.mixin(layout)
  app.mixin(responsivity)
  app.mixin(currency)
})
